import axios from 'axios';

const store = {
    namespaced: true,
    state: {
        courses: {
            highSchoolProducts: [],
            collegeProducts: [],
            dsstProducts: [],
            gradProducts: [],
            careerProducts: [],
            militaryProducts: [],
        },
    },
    actions: {
        getCourses({ commit, state }) {
            return axios
                .get('/testprep/wp-json/wp/v2/courses')
                .then((response) => {
                    const courses = response.data.map((course) => {
                        return {
                            title: course.post_title,
                            url: course.url,
                            practiceTests: course.practiceTests,
                            onlineCourses: course.onlineCourses,
                            videos: course.videos,
                            flashcards: course.flashcards,
                            categories: course.categories,
                        };
                    });

                    courses.forEach((course) => {
                        if (course.categories.some((category) => category.slug === 'high-school-test-prep')) {
                            state.courses.highSchoolProducts.push(course);
                        }

                        if (course.categories.some((category) => category.slug === 'college-test-prep')) {
                            state.courses.collegeProducts.push(course);
                        }

                        if (course.categories.some((category) => category.slug === 'dsst-clep-test-prep')) {
                            state.courses.dsstProducts.push(course);
                        }

                        if (course.categories.some((category) => category.slug === 'grad-test-prep')) {
                            state.courses.gradProducts.push(course);
                        }

                        if (course.categories.some((category) => category.slug === 'carrer-test-prep')) {
                            state.courses.careerProducts.push(course);
                        }

                        if (course.categories.some((category) => category.slug === 'military-test-prep')) {
                            state.courses.militaryProducts.push(course);
                        }
                    });
                })
                .catch((error) => {
                    throw error;
                });
        },
    },
};
export default store;
